import React from 'react';

export const RODO_CONTENT_OLSZTYN = (
  <div style={{ textAlign: 'justify'}}>
    <center><b>KLAUZULA RODO</b></center>
    <p>
      <b>
        I. Udostępnianie danych z wojewódzkiego zasobu geodezyjnego i kartograficznego wraz 
        z udostępnieniem materiałów zasobu (licencja).
      </b>
    </p>
    <p>
      Zgodnie z obowiązkiem nałożonym art. 13 Rozporządzenia Parlamentu Europejskiego
      i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych
      w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich
      danych (RODO), poniżej przekazujemy informacje dotyczące przetwarzania Pani/Pana danych osobowych:
    </p>
    <ol>
    <li>
      administratorem danych osobowych jest Województwo Warmińsko–Mazurskie 
      w zakresie zadań realizowanych przez Marszałka Województwa,
      ul. E. Plater 1, 10-562 Olsztyn (dalej: Administrator);
    </li>
    <li>
      Administrator powołał Inspektora Ochrony Danych, z którym kontakt jest możliwy pod adresem email:
      iod@warmia.mazury.pl., tel. +48 895219439, fax +48 895219409;
    </li>
    <li>
      dane osobowe przetwarzane będą w celu udostępnienia danych z wojewódzkiego zasobu geodezyjnego i 
      kartograficznego wraz z uprawnieniami do przetwarzania udostępnionych materiałów zasobu (licencja),
      na podstawie ustawy z dnia 17 maja 1989 r. Prawo geodezyjne i kartograficzne
      (Dz. U. z 2023 r. poz. 1752, 1615, 1688, 1762), oraz Rozporządzenia Ministra Rozwoju, Pracy i Technologii z dnia
      2 kwietnia 2021 r. w sprawie organizacji i trybu prowadzenia państwa zasobu geodezyjnego i
      kartograficznego (Dz.U. z 2021 r., poz.820);
    </li>
    <li>
      dane osobowe nie będą przekazywane innym odbiorcom;
    </li>
    <li>
      dane osobowe będą przechowywane nie dłużej, niż to wynika z przepisów 
      o archiwizacji;
    </li>
    <li>
      w każdym czasie przysługuje Pani/Panu prawo dostępu do swoich danych osobowych, jak również prawo żądania
      ich sprostowania, usunięcia lub ograniczenia przetwarzania;
    </li>
    <li>
      jeżeli uważa Pani/Pan, że przetwarzanie danych osobowych narusza przepisy 
      o ochronie danych osobowych, ma Pani/Pan prawo wnieść skargę do organu nadzorczego,
      tj. Prezesa Urzędu Ochrony Danych Osobowych;
    </li>
    <li>
      podanie danych osobowych jest wymogiem ustawowym i jest Pani/Pan zobowiązana/ny do ich podania,
      a konsekwencją niepodania danych osobowych, będzie nierozpatrzenie wniosku o udostępnienie materiałów
      wojewódzkiego zasobu geodezyjnego i kartograficznego.
    </li>
    </ol>

    <p>
      <b>    
        II. Udostępnianie danych z wojewódzkiego zasobu geodezyjnego 
        i kartograficznego zebranych w rejestrze publicznym na podstawie art. 15 ustawy z 17 lutego 2005 r. o
        informatyzacji działalności podmiotów realizujących zadania publiczne. 
        Zgodnie z obowiązkiem nałożonym art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z
        dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych
        i w sprawie swobodnego przepływu takich danych (RODO), poniżej przekazujemy informacje dotyczące
        przetwarzania Pani/Pana danych osobowych:
      </b>
    </p>

    <ol>
      <li>
        administratorem danych osobowych jest Województwo Warmińsko – Mazurskie 
        w zakresie zadań realizowanych przez Marszałka Województwa, ul. E. Plater 1, 
        10-562 Olsztyn (dalej: Administrator);
      </li>
      <li>
        Administrator powołał Inspektora Ochrony Danych, z którym kontakt jest możliwy pod
        adresem email: iod@warmia.mazury.pl., tel. +48895219439, fax +48895219409;
      </li>
      <li>
        dane osobowe przetwarzane będą w celu udostępnienia danych z wojewódzkiego zasobu
        geodezyjnego i kartograficznego, zgromadzonych w rejestrze publicznym, na podstawie
        ustawy z 17 lutego 2005 r. o informatyzacji działalności podmiotów realizujących zadania
        publiczne (Dz.U. z 2023 r., poz. 57 t.j.), oraz ustawy z 17 maja 1989 r. Prawo geodezyjne i
        kartograficzne (Dz.U. z 2021 r., poz. 1990 t.j.), a także Rozporządzenia Rady Ministrów z 27
        września 2005 r. w sprawie sposobu, zakresu i trybu udostępniania danych zgromadzonych w rejestrze
        publicznym (Dz.U. z 2018 r., poz. 29 t.j.);
      </li>
      <li>
        dane osobowe nie będą przekazywane innym odbiorcom;
      </li>
      <li>
        dane osobowe będą przechowywane nie dłużej, niż to wynika z przepisów 
        o archiwizacji;
      </li>
      <li>
        w każdym czasie przysługuje Pani/Panu prawo dostępu do swoich danych osobowych, jak
        również prawo żądania ich sprostowania, usunięcia lub ograniczenia przetwarzania;
      </li>
      <li>
        jeżeli uważa Pani/Pan, że przetwarzanie danych osobowych narusza przepisy o ochronie danych
        osobowych, ma Pani/Pan prawo wnieść skargę do organu nadzorczego, tj. Prezesa Urzędu Ochrony
        Danych Osobowych;
      </li>
      <li>
        podanie danych osobowych jest wymogiem ustawowym i jest Pani/Pan zobowiązana/ny do ich podania,
        a konsekwencją niepodania danych osobowych, będzie nierozpatrzenie wniosku o udostępnienie
        danych zgromadzonych w rejestrze publicznym.
      </li>
    </ol>

  </div>);

export const RODO_CONTENT = (<div>
  <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
  <title>ESPDP.PL - RODO</title>
  <meta name="generator" content="LibreOffice 6.0.7.3 (Linux)" />
  <meta name="author" content="A" />
  <meta name="created" content="2019-03-11T10:34:00" />
  <meta name="changedby" content="A" />
  <meta name="changed" content="2019-03-11T12:06:00" />
  <meta name="AppVersion" content={14.0000} />
  <meta name="DocSecurity" content={0} />
  <meta name="HyperlinksChanged" content="false" />
  <meta name="LinksUpToDate" content="false" />
  <meta name="ScaleCrop" content="false" />
  <meta name="ShareDoc" content="false" />
  <style type="text/css" dangerouslySetInnerHTML={{ __html: "\n\t\t@page { margin: 2.5cm }\n\t\tp { margin-bottom: 0.25cm; direction: ltr; line-height: 115%; text-align: left; orphans: 2; widows: 2 }\n\t\ta:link { color: #0000ff }\n\t" }} />
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <b>
          Klauzula informacyjna dot. przetwarzania danych osobowych na podstawie
          obowiązku prawnego ciążącego na administratorze (przetwarzanie w
          związku z&nbsp;Ustawą z dnia 17 lutego 2005 r. o informatyzacji
          działalności podmiotów realizujących zadania publiczne)
        </b>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%' }}>
    <br />
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <b>
          Tożsamość administratora:
        </b>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Administratorem jest GIAP Sp. z o.o. z siedzibą w Warszawie przy ul. Pasaż Ursynowski 1/126, 02-784 Warszawa. Administrator odpowiada
      za&nbsp;zapewnienie funkcjonowania elektronicznej platformy usług e-SPDP.pl.
    </font>
  </p>
  <p style={{ marginBottom: '0cm', lineHeight: '150%' }}><br />
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <b>
          Dane kontaktowe administratora:
        </b>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Z administratorem można skontaktować się:
    </font>
  </p>
  <ul>
    <li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}><a name="OLE_LINK3" /><a name="OLE_LINK2" /><a name="OLE_LINK1" />
        <font size={2} style={{ fontSize: '10pt' }}>
          pocztą elektroniczną pod adresem espdp@giap.pl,
        </font>
      </p>
    </li>
    <li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          listownie, kierując korespondencję na adres siedziby administratora.
        </font>
      </p>
    </li>
  </ul>
  <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%' }}>
    <br />
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <b>
          Dane kontaktowe inspektora ochrony danych osobowych:
        </b>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Administrator wyznaczył inspektora ochrony danych, z którym może Pani/Pan
      skontaktować się poprzez e-mail&nbsp;espdp@giap.pl. Z inspektorem
      ochrony danych może Pani/Pan kontaktować się we wszystkich sprawach dotyczących:
    </font>
  </p>
  <ul>
    <li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          przetwarzania Pani/Pana danych osobowych przez GIAP Sp. z o.o.,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          korzystania przez Panią/Pana z praw związanych z przetwarzaniem danych.
        </font>
      </p>
    </li></ul>
  <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%' }}>
    <br />
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <b>
          Cele przetwarzania i podstawa prawna:
        </b>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Pani/Pana dane są przetwarzane w celu zarządzania Pani/Pana kontem na
      e-spdp.pl i wykorzystywania tego konta:
    </font>
  </p>
  <ul>
    <li>
      <p style={{ marginRight: '0.5cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          w celu realizacji usług online, jakie zostały udostępnione na
          platformie e-spdp.pl powiązanych z&nbsp;kontem użytkownika ePUAP,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.5cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          w zakresie określonym przepisami powszechnie obowiązującego prawa,
          w tym składania podań i&nbsp;wniosków w oparciu o formularze
          elektroniczne umożliwiające realizację usług publicznych.
        </font>
      </p>
    </li></ul>
  <p style={{ marginLeft: '0.85cm', marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%' }}>
    <br />
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      <b>Podstawa prawna do przetwarzania danych:</b>
    </font>
  </p>
  <ul>
    <li>
      <p style={{ marginRight: '0.5cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          Ustawa z dnia 17 lutego 2005 r. o informatyzacji działalności podmiotów
          realizujących zadania publiczne,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.5cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          Rozporządzenie Ministra Cyfryzacji z dnia 5 października 2016 r. w sprawie zakresu
          i warunków korzystania z elektronicznej platformy usług administracji publicznej.
        </font>
      </p>
    </li></ul>
  <p style={{ marginLeft: '0.64cm', marginRight: '0.5cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <br />
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <b>
          Zakres przetwarzanych danych odbiorcy danych lub kategorie odbiorców danych:
        </b>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Pani/Pana dane osobowe będą przetwarzane także przez:
    </font>
  </p>
  <ul>
    <li>
      <p style={{ marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          Centralny Ośrodek Informatyki z siedzibą w&nbsp;Warszawie przy Alejach
          Jerozolimskich 132-136, 02-305 Warszawa, świadczący usługi
          utrzymania i&nbsp;rozwoju ePUAP oraz udzielający pomocy użytkownikom w
          zakresie niezbędnym dla realizacji tych zadań,</font></p>
    </li>
    <li>
      <p style={{ marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          oraz właściwy do sprawy podmiot publiczny (urząd samorządu gminnego)
          przetwarzający otrzymane dane w zakresie i przez okres określony
          przepisami prawa właściwymi dla gromadzenia i&nbsp;przechowywania
          przez nie dokumentacji odzwierciadlającej odpowiedni proces
          załatwiania spraw (zgodnie z przepisami wymagającymi od tych
          podmiotów zapewnienia tej dokumentacji odpowiedniej ewidencji,
          przechowywania i ochrony na podstawie art. 6 ustawy z dnia 14 lipca
          1983 o narodowym zasobie archiwalnym i archiwach).
        </font>
      </p>
    </li>
  </ul>
  <p style={{ marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%' }} />
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Przetwarzanie danych osobowych obejmuje dane podane przez użytkownika przy
      zakładaniu konta, czyli co najmniej:
    </font>
  </p>
  <ul>
    <li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          imię (imiona) nazwisko,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          adres e-mail,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          numer telefonu, telefonu komórkowego, faxu,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          PESEL,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          adres zamieszkania, adres zameldowania.
        </font>
      </p>
    </li></ul>
  <p style={{ marginLeft: '0.85cm', marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <br />
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Wraz z zakładaniem konta na e-spdp.pl i korzystaniem z elektronicznych
      usług automatycznie łączone jest tworzone konto e-spdp.pl z kontem
      ePUAP użytkownika, które służy do uwierzytelnienia się użytkownika.
    </font>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Oznacza to, że Pani/Pana dane osobowe będą mogły zostać udostępnione
      podmiotom mającym prawo do&nbsp;potwierdzania profilu zaufanego, czyli:
    </font>
  </p>
  <ul>
    <li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          konsulom,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          urzędom wojewódzkim,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          urzędom skarbowym,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          Zakładowi Ubezpieczeń Społecznych,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          podmiotom mającym zgodę ministra właściwego do spraw informatyzacji
          (obecnie Ministra Cyfryzacji) na potwierdzanie profilu zaufanego w
          punkcie potwierdzającym.
        </font>
      </p>
    </li></ul>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Udostępnienie będzie następowało wyłącznie po podaniu numeru PESEL lub
      identyfikatora użytkownika konta powiązanego ze złożonym automatycznie wnioskiem.
    </font>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <u>
          <a href="https://pz.gov.pl/pz/confirmationPointAddressesList">
            <b>
              Pełna lista punktów potwierdzających profile zaufane dostępna jest na stronie pz.gov.pl.
            </b>
          </a>
        </u>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      <br />
    </font>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <b>Okres przechowywania danych:
        </b>
      </font>
    </span></p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Dane konta użytkownika e-spdp.pl będą przetwarzane bezterminowo, aż do
      czasu usunięcia tego konta przez użytkownika.
    </font>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      W każdej chwili użytkownik ma prawo:
    </font>
  </p>
  <ul>
    <li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          zapoznać się z danymi osobowymi przetwarzanymi w ramach założonego przez
          siebie konta,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          poprawiać te dane oraz
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          usunąć ich część lub całkowicie usunąć konto na e-spdp.pl –
          korzystając z polecenia „usuń konto” dostępnego w ramach opcji zarządzania kontem.
        </font>
      </p>
    </li></ul>
  <p style={{ marginLeft: '1.27cm', marginRight: '0.85cm', marginBottom: '0cm', lineHeight: '150%' }}>
    <br />
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <b>
          Prawa podmiotów danych:
        </b>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Przysługuje Pani/Panu prawo dostępu do Pani/Pana danych oraz prawo żądania ich
      sprostowania lub usunięcia. Możliwe jest to po uwierzytelnieniu się
      na założonym przez siebie koncie e-spdp.pl w sposób ustalony przez użytkownika tego konta.
    </font>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <br />
  </p>
  <p style={{ marginRight: '0.42cm', textIndent: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Zmiana danych konta lub usunięcie konta nie spowoduje jednak:
    </font>
  </p>
  <ul>
    <li>
      <p style={{ marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
        <font size={2} style={{ fontSize: '10pt' }}>
          zmiany i usunięcia danych ePUAP, jakie zostało automatycznie powiązane
          oraz zmiany i&nbsp;usunięcia danych profilu zaufanego,
        </font>
      </p>
    </li><li>
      <p style={{ marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}><a name="OLE_LINK7" /><a name="OLE_LINK6" /><a name="OLE_LINK5" /><a name="OLE_LINK4" />
        <font size={2} style={{ fontSize: '10pt' }}>zmiany
          i usunięcia danych przekazanych do podmiotów publicznych w ramach
          korzystania z&nbsp;usług publicznych na ePUAP, ponieważ
          administratorami tych danych są te podmioty publiczne
          przetwarzające otrzymane dane w zakresie i przez okres określony
          przepisami prawa właściwymi dla gromadzenia i przechowywania przez
          nie dokumentacji odzwierciadlającej odpowiedni proces załatwiania
          spraw (zgodnie z przepisami wymagającymi od tych podmiotów
          zapewnienia tej dokumentacji odpowiedniej ewidencji, przechowywania
          i ochrony na podstawie art. 6 ustawy z&nbsp;dnia 14 lipca 1983 o
          narodowym zasobie archiwalnym i archiwach).
        </font>
      </p>
    </li></ul>
  <p style={{ marginLeft: '1.27cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%' }}>
    <br />
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <b>
          Prawo wniesienia skargi do organu nadzorczego:
        </b>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Przysługuje Pani/Panu również prawo wniesienia skargi do organu nadzorczego
      zajmującego się ochroną danych osobowych w państwie członkowskim
      Pani/Pana zwykłego pobytu, miejsca pracy lub miejsca popełnienia
      domniemanego naruszenia.
    </font>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      Prezes Urzędu Ochrony Danych Osobowych (PUODO) ul. Stawki 2 00-193 Warszawa
    </font>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <u>
          <a href="https://uodo.gov.pl/p/kontakt">
            <b>
              Szczegółowe informacje kontaktowe do UODO są dostępne pod tym linkiem.
            </b>
          </a>
        </u>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}>
    <font size={2} style={{ fontSize: '10pt' }}>
      <br />
    </font>
    <span style={{ display: 'inline-block', border: 'none', padding: '0cm' }}>
      <font size={2} style={{ fontSize: '10pt' }}>
        <b>
          Informacja o dowolności lub obowiązku podania danych:</b>
      </font>
    </span>
  </p>
  <p style={{ marginLeft: '0.42cm', marginRight: '0.42cm', marginBottom: '0cm', lineHeight: '150%', textAlign: 'justify' }}><a name="_GoBack" /><a name="OLE_LINK12" /><a name="OLE_LINK11" /><a name="OLE_LINK10" /><a name="OLE_LINK9" /><a name="OLE_LINK8" />
    <font size={2} style={{ fontSize: '10pt' }}>
      Różne usługi mogą wymagać podawania różnego zakresu danych osobowych
      wymaganego przepisami prawa (w szczególności określonych
      przepisami prawa wzorami podań i wniosków wymaganych do&nbsp;załatwienia
      danej sprawy). Niepodanie kompletnych danych może skutkować
      niemożliwością realizacji usługi lub zwrotną korespondencją wymagającą uzupełnienia danych.
    </font>
  </p>
  <p style={{ marginBottom: '0cm', lineHeight: '150%' }}>
    <br />
  </p>
</div>);


// WEBPACK FOOTER //
// src/components/utils/RODO.js